module.exports = __webpack_public_path__ + "static/media/221fdbb8-9b84-49c1-ac9c-d9a11334830d.06e73c32.jpg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/chicago-council-headshots/dist/img/headshots/221fdbb8-9b84-49c1-ac9c-d9a11334830d.jpg
// module id = 805
// module chunks = 0